<template>
  <main class="main-page" style="height: 100%">
    <v-container fluid style="height: 100%">
      <div id="problemreport">
        <Avatar :img="img" :displayName="displayName"></Avatar>
        <v-row v-if="topics.length > 1">
          <v-col cols="12">
            <h2 style="color: #7ed321">เรื่องที่ต้องการแจ้ง</h2>
            <br />
            <v-select
              v-model="topic"
              :items="topics"
              item-text="label"
              item-value="value"
              label="กรุณาเลือกเรื่องที่ต้องการแจ้ง"
              solo-inverted
              hide-details
            ></v-select>
            <v-row style="margin-bottom: 5px">
              <v-col cols="12" style="color: #7ed321; font-size: 12px"
                >Topic
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <DepositIssueForm
          v-if="topic === 'deposit'"
          :key="topic"
          :line-id="lineId"
        />
        <ReportIssueForm
          v-else
          :key="topic"
          :topic="topic"
          :line-id="lineId"
          :display-name="displayName"
        />
      </div>
    </v-container>
  </main>
</template>

<script>
import Avatar from "../components/Avatar";
import DepositIssueForm from "../components/issue/DepositIssueForm.vue";
import ReportIssueForm from "../components/issue/ReportIssueForm.vue";
import liff from "@line/liff";
import { ISSUE_TOPICS, DEFAULT_TOPIC } from "../config/issueTopics.js";

export default {
  name: "ProblemReport",
  components: {
    Avatar,
    DepositIssueForm,
    ReportIssueForm,
  },
  data: () => ({
    img: "",
    displayName: "",
    lineId: "",
    topic: DEFAULT_TOPIC,
    topics: ISSUE_TOPICS,
  }),
  created() {
    this.getLineLiff();
  },
  methods: {
    getLineLiff() {
      liff
        .init({
          liffId: "1657076095-5bEex6RV", // prod
          // liffId: "1657078715-18BnkoZy", //local
        })
        .then(async () => {
          if (liff.isLoggedIn()) {
            let getProfile = await liff.getProfile();
            this.displayName = getProfile.displayName;
            this.img = getProfile.pictureUrl;
            this.lineId = getProfile.userId;
          } else {
            liff.login();
          }
        })
        .catch(() => {
          // LIFF init failed: leave profile empty, the form still renders
        });
    },
  },
};
</script>

<style>
.select .v-input__slot {
  align-items: flex-start !important;
}
</style>
